import { useState } from 'react';

/**
 * One country flag, by ISO 3166-1 alpha-2 code.
 *
 * The flags are static files under `public/flags/` — the same treatment
 * `public/icons/` gets — rather than a component library, because the two
 * country pickers list all 250 of them and `react-world-flags` inlined every
 * one as a data URI: 3.6MB of the bundle, every byte of it downloaded to draw
 * at most a handful. As files the browser fetches only what it draws and
 * caches each one on its own.
 *
 * `fallback` is what a code with no flag renders instead, decided by the
 * request failing rather than by a manifest — there is nothing to keep in
 * sync, and a deleted file degrades the same way a missing code does.
 */
export default function Flag({ code, fallback = null, ...rest }) {
  const [missing, setMissing] = useState(false);
  const cc = String(code ?? '').toLowerCase();

  if (!cc || missing) return fallback;

  return (
    <img alt="" {...rest} src={`/flags/${cc}.svg`} onError={() => setMissing(true)} />
  );
}
